const metaData = {
  'about-us': {
    title: 'Marvel | About Us | Behind Our Design Thinking Mission ',
    description:
      'Meet the minds behind Marvel and read more about our mission to transform businesses through implementing design thinking.',
  },
  'case-studies': {
    buzzfeed: {
      title: 'Marvel | Digital Design Platform | Buzzfeed Case Study',
      description: 'How Marvel Provides Buzzfeed with a Single Source of Truth',
      keywords: '',
    },
    cabify: {
      title: 'Marvel | Digital Design Platform | Cabify Case Study',
      description:
        'How Cabify closed design feedback loops to 15 minutes with Marvel',
      keywords: '',
    },
    cookpad: {
      title: 'Marvel | Digital Design Platform | CookPad Case Study',
      description:
        'How Cookpad uses Marvel to tackle the big risks in product design, early on',
      keywords: '',
    },
    'design-museum': {
      title: 'Marvel | Digital Design Platform | Design Museum Case Study',
      description:
        'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
      keywords: '',
    },
    deliveroo: {
      title: 'Marvel | Digital Design Platform | Deliveroo Case Study',
      description:
        'How Deliveroo speed up iteration and drive great design with Marvel',
      keywords: '',
    },
    hudl: {
      title: 'Marvel | Digital Design Platform | Hudl Case Study',
      description:
        'How Hudl drive great UX through daily user testing with Marvel',
      keywords: '',
    },
    laboratoria: {
      title: 'Marvel | Digital Design Platform | Laboratoria Case Study',
      description:
        "How Laboratoria's students foster design learning in design with Marvel",
      keywords: '',
    },
    mode: {
      title: 'Marvel | Digital Design Platform | Mode Case Study ',
      description:
        "How Marvel's Handoff transformed Mode's design to development communication",
      keywords: '',
    },
    monzo: {
      title: 'Marvel | Digital Design Platform | Monzo Case Study',
      description: 'How Marvel keeps Monzo shipping every two weeks',
      keywords: '',
    },
    nokia: {
      title:
        'How Nokia uses Marvel to collaborate effectively across global teams',
      description: '',
      keywords: '',
    },
    trusona: {
      title: 'Marvel | Digital Design Platform | Trusona Case Study',
      description:
        'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
      keywords: '',
    },
    yieldr: {
      title: 'Marvel | Digital Design Platform | Yieldr Case Study',
      description:
        'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
    },
    zinc: {
      title: 'Marvel | Digital Design Platform | Zinc Case Study',
      description: 'Why Zinc introduces Marvel to their incubator startups',
      keywords: '',
    },
  },
  'contact-us': {
    title: 'Marvel | Contact Us',
    description: 'Our contact details and where to find us',
    keywords: '',
  },
  consultancies: {
    title: 'Marvel for Consulting | Drive Innovation through Design',
    description:
      "Explore how Marvel's collaborative design platform can help introduce innovation management and design thinking for digital transformation.",
  },
  'customer-stories': {
    title: 'Marvel | Customer Stories',
    description:
      "Find out how we're helping the world's most innovative companies democritise design",
    keywords: '',
  },
  'data-processing-addendum': {
    title: 'Marvel | Data Processing Addendum',
    description: 'Our data processing addendum for Marvel.',
    keywords: '',
  },
  examples: {
    title: 'Marvel | Example Prototypes',
    description:
      'Discover the endless possibilities of building prototypes in Marvel. Click an example to see it in action.',
  },
  developers: {
    authentication: {
      title: 'API Authentication',
      description:
        'Find out how to generate OAuth2 access tokens in order to make API requests on behalf of users, or generate a personal access token for your own account',
    },
    'authentication-pkce': {
      title: 'API authentication using OAuth2 & PKCE',
      description:
        'Learn about the extended PKCE authorization_code OAuth2 flow for mobile and client-side apps',
    },
    commenting: {
      title: 'Tutorial: Create or retrieve comments',
      description:
        'Learn how to leave or retrieve comments on designs using our web API',
    },
    'contact-us': {
      title: 'Contact us',
      description:
        'Get in touch with any questions, queries or comments regarding the design platform API',
    },
    embeds: {
      title: 'Prototype Embeds',
      description:
        'Learn how to embed Marvel prototypes in external sites & applications',
    },
    homepage: {
      title: 'Marvel | Access our API and Build Your Own Integrations',
      description:
        'Build amazing tools and API integrations with our API platform, built with GraphQL. Our documentation is available so you can get started right away.',
    },
    'developer-documentation': {
      title: 'Marvel | API Documentation ',
      description:
        'Integrate your favorite tools with our all-in-one design platform using the Marvel Web API',
    },
    uploads: {
      title: 'Image Uploads',
      description:
        'Get your design work onto the Marvel platform using our web API',
    },
    'getting-started': {
      title: 'Getting Started',
      description:
        "Get started building on Marvel's all-in-one design platform",
    },
    pagination: {
      title: 'API Pagination',
      description:
        'Learn about how pagination works within the Marvel GraphQL web API',
    },
    'screen-arrangement': {
      title: 'Screen Arrangement',
      description:
        'Learn about managing screens within Marvel prototypes and organising them within sections',
    },
    terms: {
      title: 'Terms and Conditions',
      description: 'Terms and Conditions of our API',
    },
    tutorials: {
      title: 'API Tutorials',
      description:
        'Find a range of tutorials covering the most common uses of our design platform web API',
    },
  },
  'ebook-collaboration-handoff-edition': {
    title: 'Marvel | Free eBook | Book of Collaboration: Handoff Edition',
    description:
      'In our free eBook learn how to drive consistency, strengthen communication and transform the design-to-development process. Challenge design handover frustrations with forward thinking solutions.',
  },
  'ebook-design-systems': {
    title: 'Marvel | Free eBook | Getting Started with Design Systems ',
    description:
      'A free guide to getting started with design systems. Simple in structure, human in explanation and packed with insight',
  },
  enterprise: {
    title:
      'Marvel Enterprise | The Design, Prototyping and User Testing Platform for Large Teams to Scale Design',
    description:
      "The World's Most Innovative Companies Use Marvel Everyday To Scale Design. All The Tools You Need To Brainstorm, Design, Prototype, User Test and Handoff to Developers In A Single Platform.",
    keywords:
      'Prototyping, Prototyping Tool, UX prototyping, design systems, design assets, SSO, inspect designs, developer handoff, design to code, Design, Wireframe, Wireframe Tool, User Testing, iOS prototyping, android prototyping, website prototyping, paper prototyping, remote user testing, unmoderated user testing, guerilla user testing ',
  },
  'request-demo': {
    title: 'Marvel | Request a Personalised Demo of Marvel Enterprise',
    description:
      'All the tools you need to design, prototype, user test and handoff code in one place.',
    keywords: 'enterprise design, design thinking, design thinking process',
  },
  features: {
    collaboration: {
      title: 'Marvel | Online Design Collaboration & Feedback Platform',
      description:
        'Your workspace for design feedback and collaboration with our collaboration tools within Marvel.',
      keywords:
        "'collaboration tools, productivity tools, collaborative design, design collaboration software, design collaboration tools, design collaborative, online collaboration tools, online design collaboration'",
    },
    design: {
      title: 'Marvel | Online Free Digital Design Platform & Mockup App ',
      description:
        'Design online and quickly create beautiful mockups, banners and more in our intuitive design tool. No coding required. Get started for free.',
      keywords:
        'free design tools, design online, online design tool, design tool software',
    },
    handoff: {
      title: 'Marvel | UI, UX Design & Developer Handoff Tool',
      description:
        'Generate design specs for developers automatically. Transform designs from sketch to CSS, Swift and Android XML.',
      keywords:
        'sketch to html, designer specs, design handoff, design handoff tools, design to code, collaboration',
    },
    integrations: {
      title: 'Marvel Integrations | Connect with Sketch, Jira and more',
      description:
        'Power up your workflow and get more done with integrations.',
      keywords:
        'integrations, design integrations, api, automation, design, design process',
    },
    prototyping: {
      title: 'Marvel | Free Prototype Platform for Website & Mobile Apps',
      description:
        'Marvel turns sketches and mockups into realistic apps within minutes, helping communicate digital ideas better. Get started for free. ',
      keywords:
        'free prototyping, ios prototyping, free prototyping, android prototyping, web prototyping, desktop prototyping',
    },
    wireframing: {
      title: 'Marvel | Rapid Wireframe Tool for iOS, Android & Desktop',
      description:
        'Wireframe apps, websites and more with the thousands of assets, templates and assets from our wireframing tool, directly in your browser.',
      keywords:
        'wireframe, wireframe tools, wireframing, wireframe app, mockup tool, wireframe software',
    },
  },
  'financial-services': {
    title: 'Marvel for Finance | Create Better Customer Experiences',
    description:
      "Explore how Marvel's collaborative design platform can help your financial business create a better customer experience and drive digital transformation.",
  },
  homepage: {
    title:
      'Marvel - The design platform for digital products. Get started for free.',
    description:
      'The collaborative design platform. Wireframe, prototype, user test, design and inspect designs in one place, for free! Or create an integration with our API.',
    keywords:
      'prototype, prototyping, design online, wireframe, design platform, designer specs, api, api integration, design platform, online collaboration tools, collaboration tools, design thinking, mockup tool, product design',
  },
  integrations: {
    'atlassian-confluence': {
      title: 'Marvel & Confluence | Embed Website & App Prototypes',
      description:
        'Our Confluence integration allows you to to quickly add website and app prototypes made in Marvel to your documents by simply adding a URL.',
      keywords: 'atlassian, product management, embed prototypes, prototyping,',
    },
    'atlassian-jira': {
      title: 'Marvel & JIRA | Embed Website and App Prototypes',
      description:
        'With Marvel for Jira, you can quickly embed interactive prototypes to issues by simply adding a Marvel URL into Jira issues.',
      keywords: 'atlassian, product management, embed prototypes, prototyping',
    },
    botbot: {
      title: 'Marvel & BotBot | Prototype Commands into Slack',
      description:
        'BotBot is a Slack chatbot which enables you to send commands directly to Marvel, like creating projects, adding collaborators and listing projects.',
      keywords: 'Slackbot, design productivity, collaboration, prototyping',
    },
    dashboard: {
      title: 'Marvel & Dashboard | Real Time Design Updates for TVs',
      description:
        'View your teams Marvel design activity in a visually dynamic format with Dashboard, improving transparency, productivity and collaboration.',
      keywords: 'dashboard, collaboration, productivity',
    },
    'dropbox-paper': {
      title: 'Marvel & Dropbox Paper | Embed Prototypes',
      description:
        'This integration allows you to embed fully interactive prototypes by simply pasting a link; click through mock-ups without leaving your Paper document.',
      keywords: 'design, embed prototypes, prototyping, design files',
    },
    'google-drive': {
      description:
        'Select any design file from your Google Drive account and add it to your Marvel project. Everything is kept updated in real-time as you make changes.',
      keywords: 'file sharing, design files, collaboration, prototyping',
    },
    keynote: {
      title: 'Marvel & Keynote | Turn Presentations into Prototypes',
      description:
        'With Marvel for Keynote, sync slides with Marvel and effortlessly transform them into prototypes for websites and apps. Present ideas better with prototypes.',
      keywords: 'Presentations, prototypes',
    },
    lookback: {
      title: 'Marvel & Lookback | Remote User Testing for your Prototypes',
      description:
        'Record videos of users interacting with Marvel prototypes, generating a timeline of test activity plus a segmented and timestamped view of each design.',
      keywords: 'user testing, prototypes, prototyping',
    },
    maze: {
      title: 'Marvel & Maze | Gain Analytics on your Prototypes',
      description:
        'Analytics tool for Marvel prototypes for defining goals, collecting actionable insights and analysing how your mockup has performed in user testing sessions.',
      keywords: 'analytics tool, prototypes, user testing, analytics',
    },
    microsoft: {
      title: 'Marvel & Microsoft Teams | Collaborate on Prototypes',
      description:
        'Microsoft Teams is a platform for workplace chat. With our integration, Microsoft Teams users can access Marvel projects and features directly within the app',
      keywords: 'collaboration, communication, design, prototyping',
    },
    niice: {
      title: 'Marvel & Niice | Moodboards for Collaboration',
      description:
        'Our Niice integration allows you to create beautiful moodboards using Marvel prototypes with sketches, videos, animations and more.',
      keywords: 'moodboards, prototyping, inspiration, design, collaboration',
    },
    sketch: {
      title: 'Marvel & Sketch | Sync Sketch Designs into Marvel',
      description:
        'Our popular Sketch plugin lets you upload your designs directly from Sketch to your Marvel projects and keep them in sync.',
      keywords: 'sketch prototyping, sketch plugin, prototyping, design',
    },
    smartmockups: {
      title: 'Marvel & Smartmockups | Create Stunning Product Shots',
      description:
        'Turn any design in your Marvel project into a beautiful product shot, perfect to drop into your slides and presentations.',
      keywords: 'design, marketing, prototypes',
    },
    userflows: {
      title: 'Marvel & UserFlows | Generate Sitemaps for Prototypes',
      description:
        "Display your Marvel prototype's UX flow and user journey with Userflows",
      keywords: 'mapping, prototypes, user flows, journeys',
    },
    youtube: {
      title: 'Marvel & YouTube | Embded Videos into Prototypes',
      description:
        'Add rich and dynamic content to your Marvel prototypes by simply copying the embed code from YouTube into a Marvel hotspot.',
      keywords: 'video, embed video, prototyping, prototypes, app prototyping',
    },
    zeroheight: {
      title: 'Marvel & Zeroheight | Embed Prototypes into a Design System',
      description:
        'Embed Marvel prototypes into your design system documents in Zeroheight',
      keywords: 'design systems, styleguides, prototyping, prototypes, dsm',
    },
  },
  'marvel-vs-invision': {
    title:
      'InVision vs. Marvel – Learn About InVision Alternatives | Marvel Design Platform',
    description:
      'Learn about Marvel vs. Inision. Marvel offers all the tools you need to design, prototype, user test and handoff code in one place.',
  },
  'marvel-vs-zeplin': {
    title:
      'Zeplin Vs Marvel comparison – explore Zeplin alternatives for code handoff',
    description:
      'Read about Zeplin vs Marvel - compare the benefits of using Marvel for your design to developer code handoff versus Zeplin.',
  },
  labs: {
    title: 'Marvel Labs | Open Source Projects & Resources',
    description:
      'Explore work from the Marvel team including prototyping templates, open source projects and articles',
    keywords: 'labs, open source, projects, resources, freebies, design',
  },
  privacy: {
    title: 'Marvel | Privacy',
    description:
      'Marvel Prototyping Limited respects your privacy and is committed to protecting your personal data. ',
  },
  'prototyping-for-design-agencies': {
    title: 'Marvel for Agencies | Design Collaboration Platform',
    description:
      'Design and Prototyping for Design Agencies. Explore how Marvel can help you deliver beautiful design work to clients in one collaborative platform.',
  },
  resources: {
    homepage: {
      title: 'Marvel | Free Design Resources | Webinars, eBooks and more',
      description:
        'A library of resources including case studies, webinars and eBooks on topics including Design Thinking and User Testing',
    },
    workshops: {
      title: 'Marvel | Free eBook | The Design Thinking Workshop Kit',
      description:
        'Learn how to run your first Design Thinking session, learn how to apply the stages empathise, define, ideate, prototype and test to any problem, in one workshop',
    },
  },
  security: {
    title: 'Marvel | Security',
    description:
      'Information on how we keep your data secure and remain GDPR compliant.',
  },
  'bounty-policy': {
    title: 'Marvel | Bug Bounty Policy',
    description:
      'Information on our bug bounty policy and security incident policy for security researchers and professionals ',
  },
  signin: {
    title: 'Marvel | Sign in',
    description:
      'Sign in to your Marvel account and access all of our great features.',
    keywords: '',
  },
  signup: {
    title: 'Marvel | Create your free account',
    description: 'Get started with your free Marvel account ',
    keywords: '',
  },
  terms: {
    title: 'Marvel | Terms ',
    description: 'Terms and conditions for Marvel',
    keywords: '',
  },
  sketch: {
    title: 'Marvel & Sketch Prototyping | Sync Artboards and Hotspots',
    description:
      'Seamlessly import prototype and sync artboards from Sketch into Marvel',
  },
  sketchpad: {
    title: 'Marvel | Download Device Templates for Rapid Prototyping',
    description:
      'Want to prototype on paper? Download free device templates here for iOS and Android devices and create early design mockups. Perfect for rapid prototyping',
  },
  'user-testing': {
    title: 'Marvel | UX, UI & Design User Testing & Feedback Platform ',
    description:
      'Turn prototypes into usability tests and get user feedback before moving to dev. User tests include video, audio & insights, perfect for user interviews & remote testing. Get started for free!',
  },
  'why-marvel': {
    title: 'Marvel | Explore our Digital Design Platform Features',
    description:
      "Explore Marvel's features that'll take you from design to prototyping, user testing and handoff. All in one platform",
  },
  glossary: {
    title: 'Design & Prototyping Glossary | Marvel',
    description:
      'Your guide to industry terminology across design, prototyping, usability and user testing',
  },
};

export default metaData;



// WEBPACK FOOTER //
// ./src/data/metadata.js